import React from "react";
import styled from "styled-components";
import { breakPoint } from "../../utils/breakPoints";

const Projects = styled.div`
    .projects-con {
        position: relative;
        margin: auto;
        width: 76%;
        min-height: 260px;
        display: grid;
        grid-template-columns: 260px 1fr;
        gap: 32px;
        align-items: stretch;
        margin-top: 5%;
        margin-bottom: 5%;
        color: ${(props) => props.theme.primaryText};
    }

    .impact-panel {
        border: 3px solid ${(props) => props.theme.border};
        background: ${(props) => props.theme.buttonBg};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        text-align: center;
    }

    .impact-value {
        font-size: 2em;
        font-weight: bold;
        color: ${(props) => props.theme.importentText};
    }

    .company {
        margin-top: 12px;
        font-size: 0.9em;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .project-title {
        font-size: 1.7em;
        font-weight: bold;
        margin-bottom: 16px;
    }

    .project-discription {
        background: ${(props) => props.theme.primaryText};
        color: ${(props) => props.theme.bg};
        border-radius: 8px;
        min-height: 110px;
        font-size: 1em;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 24px;
        text-align: left;
        font-weight: lighter;
    }

    .projects-others {
        margin-top: 18px;

        .tech-stacks {
            font-size: 0.7em;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 8px;
        }

        .tech-name {
            background: ${(props) => props.theme.buttonBg};
            padding: 6px 8px;
            border-radius: 4px;
        }
    }

    @media (max-width: ${breakPoint.tablet}) {
        margin-bottom: 100px;

        .projects-con {
            width: 82%;
            display: block;
            margin-bottom: 0;
        }

        .impact-panel {
            min-height: 150px;
            margin-bottom: 20px;
        }

        .project-title {
            font-size: 1.3em;
        }

        .project-discription {
            font-size: 0.75em;
            padding: 18px;
        }

        .projects-others {
            .tech-stacks {
                align-items: center;
                justify-content: center;
            }
        }
    }
`;

export const ProjectComponent = ({
    el: { title, company, about, tech, impact },
}) => {
    return (
        <Projects>
            <div className="projects-con">
                <div className="impact-panel">
                    <div className="impact-value">{impact}</div>
                    <div className="company">{company}</div>
                </div>

                <div>
                    <div className="project-title">{title}</div>
                    <div className="project-discription">{about}</div>
                    <div className="projects-others">
                        <div className="tech-stacks">
                            {tech.map((el) => (
                                <span className="tech-name">{el}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Projects>
    );
};
